import React from 'react'
import './styles.css'

export function CaptchaNotice({ dark }) {
  return (
    <p className={!dark ? 'captcha-notice' : 'captcha-notice dark'}>
      This site is protected by Turnstile and the Cloudflare{' '}
      <a href="https://www.cloudflare.com/privacypolicy/">Privacy Policy</a> and{' '}
      <a href="https://www.cloudflare.com/website-terms/">Terms of Service</a> apply.
    </p>
  )
}

export default CaptchaNotice
